import { Component, OnChanges, OnInit, Input, Output, EventEmitter, AfterViewInit, SimpleChanges } from '@angular/core';

@Component({
  selector: "app-stepper",
  templateUrl: "./stepper.component.html",
  styleUrls: ["./stepper.component.scss"],
})
export class StepperComponent implements OnChanges, OnInit, AfterViewInit {
  @Input() steps: Array<any> = [''];
  @Input() iconsClassName: Array<any> = [''];
  @Input() allActive = false;

  // Si usas el stepper desplegado (allActive como true), pero quieres que haya un pequeño apartado desplegable dentro del .step-content
  @Input() heightToAdd = 0;
  @Input() sectionPosition = 0;
  @Input() accordionAction = ''; // Ej.: openApartadoConcreto/closeApartadoConcreto
 
  @Output() stepChange = new EventEmitter<number>();

  public currentStep: number = 0;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['accordionAction']) {
      // La primera vez (cuando se carga la respuesta) no devuelve ningún valor
      if (changes['accordionAction'].firstChange) {
        return;
      } else {
        let sectionsContent = document.querySelectorAll<HTMLElement>('.step-content');
        if (changes['accordionAction'].currentValue.includes('open')) {
          // 32 es el padding-bottom del .step-content
          sectionsContent[this.sectionPosition].style.height = (sectionsContent[this.sectionPosition].offsetHeight - 32) + this.heightToAdd + "px";
        } else if (changes['accordionAction'].currentValue.includes('close')) {
          sectionsContent[this.sectionPosition].style.height = sectionsContent[this.sectionPosition].offsetHeight - (this.heightToAdd + 32) + "px";
        }
      }
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {
    let sectionsContent = document.querySelectorAll<HTMLElement>('.step-content');
    let externalContent = document.querySelectorAll<HTMLElement>('[data-step]');
    this.steps.forEach((element, index) => {
        sectionsContent[index].appendChild(externalContent[index]);
        sectionsContent[index].style.height = externalContent[index].offsetHeight.toString() + 'px';
    });
  }

  public toggleStep(index: number) {
    if (!this.allActive) {
      if (this.currentStep === index) {
        this.currentStep = -1;
      } else {
        this.currentStep = index;
      }
  
      this.stepChange.emit(this.currentStep);
    }
  }
}
